<template>
    <modal class="multiUnitModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">沽清操作</div>
        <div class="modal-body">
            <div class="title-box">
                菜品名称：<span>{{multipleSizeFoods?.Food_Name}}</span>
            </div>
            <div class="item-box" v-scroll-anime="{up:'item-up2',down:'item-down2',liClass:'.item-li',marginH:10,paddingH:8,isRow:false}">
                <div class="item-li" :class="{selected:item.selected}" v-for="item in MultipleList" :key="item" @click="onDescClick(item)" >
                    <p class="title">￥{{item.Food_Price}}</p>
                    <p class="tit-unit">{{item.Food_Size}}</p>
                    <!-- 促销价 -->
                    <div class="cxPrice" v-if="item.Is_Promotion">
                        <div class="cxTag">促</div>
                        <div class="unit">￥</div>{{item.Promotion_Price}}
                    </div>
                    <!-- vip 价格 -->
                    <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                        <div class="vipTag">VIP</div>
                        <div class="price"> 
                            <div class="unit">￥</div>{{item.Food_VipPrice}}
                        </div>
                    </div>
                    <tag-sold-out v-if="item.Is_SoldOut"></tag-sold-out>
                    <i class="iconfont icon-gou-fine"></i>
                </div>
            </div>
            <div class="item-operation">
                <div class="float-right">
                    <div class="bnt-fangxiang" ref="item-up2"><i class="iconfont icon-fangxiang-up"></i></div>
                    <div class="bnt-fangxiang" ref="item-down2"><i class="iconfont icon-fangxiang-down"></i></div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="cancel()">全部取消沽清</button>
            <button class="btn btn-confirm" @click="confirm()">全部沽清</button>
        </div>
     </modal>
</template>

<script>

export default {
    name:'changeUnitModel',
    emits:["close","confirm","cancel"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        //多单位数据
        multipleSizeFoods:{
            type:Object
        }
    },
    data(){
        return {
            FoodID:-1,
            MultipleFoods:'',
            MultipleList:[]
        }
    },
    watch:{
        /**打开换单位页面 */
        isShow(){
            if(!this.isShow) return;
            this.openimp()
        }
    },
    mounted(){
        this.$nextTick(()=> {
           this.openimp()
        })
    },
    methods:{
        /**打开执行 */
        openimp(){
            if(this.multipleSizeFoods){
                this.MultipleList=[this.multipleSizeFoods]
                this.multipleSizeFoods?.MultipleSizeFoods?.forEach(item=>{
                    item.SubCategory_Name=this.multipleSizeFoods.SubCategory_Name,//类别名称
                    this.MultipleList.push(item);
                })
                this.MultipleList;
            }
        },
        hide(){
            this.$emit("close");
        },
        confirm(){
            let list=this.MultipleList?.filter(item=>!item.Is_SoldOut)

            if(!(list.length>0)){
                this.$message.error('没有可沽清的菜品!');
            }else{
                this.$emit("confirm",list);
            }
        },
        cancel(){
            let list=this.MultipleList?.filter(item=>item.Is_SoldOut);
            if(!(list.length>0)){
                this.$message.error('没有可取消沽清的菜品!');
            }else{
                this.$emit("cancel",list);
            }
        },
        /**菜品点击 */
        onDescClick(item){
            this.$confirm(`菜品名称:<span style="color:red;font-size:24px">${item.Food_Name}</span>`, item.Is_SoldOut?"取消沽清":"沽清操作", {
                dangerouslyUseHTMLString:true,
                confirmButtonText: item.Is_SoldOut?"确认取消沽清":"确认沽清",
                cancelButtonText:"取消",
                callback: (name) => {
                    if(name=='confirm'){
                        if(item.Is_SoldOut){
                            this.$emit("cancel",[item]);//取消沽清
                        }else{
                            this.$emit("confirm",[item]);//沽清
                        }
                    }
                },
            }); 
            
        }
    }
}
</script>

<style lang="scss">
@import "./multiUnitModel.scss";
</style>